import Form from "./form/Form";
import Layout from "./layout/Layout";
import OICAutoLink from "./oic/OICAutoLink";
import OICVerify from "./oic/OICVerify";
import LogOut from "./pages/LogOut";
import NotFound from "./pages/NotFound";

const Routes = () => {
  return [
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/", element: <Form /> },
        { path: "login", element: <Form /> },
        { path: "logout", element: <LogOut /> },
        { path: "signup", element: <Form formType="signUp" /> },
        { path: "verify", element: <Form formType="verify" /> },
        { path: "forgotpassword", element: <Form formType="forgotPassword" /> },
        { path: "oauth2/idpresponse", element: <OICVerify /> },
        { path: "oauth2/idlink", element: <OICAutoLink /> },

        { path: "*", element: <NotFound /> },
      ],
    },
  ];
};

export default Routes;
